// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_buyerSection__GYyU2 {
  background-color: var(--background-color1);
  padding: 6rem 0;
}

.styles_sectionTitle__L0eGU {
  font-size: 2.2rem;
  font-weight: 700;
  text-align: center;
  color: var(--text-color0);
  margin-bottom: 1rem;
}

.styles_divider__WH9im {
  width: 5rem;
  height: 4px;
  background-color: var(--brand-yellow);
  border: none;
  border-radius: 2px;
  margin: 1.5rem auto 3.5rem auto;
}

.styles_buyerGrid__TIIT6 {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 4rem;
  align-items: center;
}

@media (max-width: 900px) {
  .styles_buyerGrid__TIIT6 {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
}

.styles_buyerImageWrapper__qTL8k {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
}

.styles_buyerImage__LJsUZ {
  max-width: 100%;
  height: auto;
  border-radius: 1.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: transform 0.4s ease;
}

.styles_buyerImage__LJsUZ:hover {
  transform: scale(1.02);
}

.styles_highlight__TDvUs {
  color: var(--brand-yellow);
}

.styles_sectionSubtitle__3RvIW {
  color: var(--brand-yellow);
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
}

.styles_buyerTextContainer__atY5V {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.styles_buyerDetails__RDoky {
  font-size: 1.1rem;
  color: var(--text-color1);
  line-height: 1.7;
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/CadastroLoja/components/BuyerSection/styles.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".buyerSection {\n  background-color: var(--background-color1);\n  padding: 6rem 0;\n}\n\n.sectionTitle {\n  font-size: 2.2rem;\n  font-weight: 700;\n  text-align: center;\n  color: var(--text-color0);\n  margin-bottom: 1rem;\n}\n\n.divider {\n  width: 5rem;\n  height: 4px;\n  background-color: var(--brand-yellow);\n  border: none;\n  border-radius: 2px;\n  margin: 1.5rem auto 3.5rem auto;\n}\n\n.buyerGrid {\n  display: grid;\n  grid-template-columns: 1.1fr 0.9fr;\n  gap: 4rem;\n  align-items: center;\n}\n\n@media (max-width: 900px) {\n  .buyerGrid {\n    grid-template-columns: 1fr;\n    gap: 3rem;\n  }\n}\n\n.buyerImageWrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n\n.buyerImage {\n  max-width: 100%;\n  height: auto;\n  border-radius: 1.5rem;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  transition: transform 0.4s ease;\n}\n\n.buyerImage:hover {\n  transform: scale(1.02);\n}\n\n.highlight {\n  color: var(--brand-yellow);\n}\n\n.sectionSubtitle {\n  color: var(--brand-yellow);\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n}\n\n.buyerTextContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.buyerDetails {\n  font-size: 1.1rem;\n  color: var(--text-color1);\n  line-height: 1.7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buyerSection": `styles_buyerSection__GYyU2`,
	"sectionTitle": `styles_sectionTitle__L0eGU`,
	"divider": `styles_divider__WH9im`,
	"buyerGrid": `styles_buyerGrid__TIIT6`,
	"buyerImageWrapper": `styles_buyerImageWrapper__qTL8k`,
	"buyerImage": `styles_buyerImage__LJsUZ`,
	"highlight": `styles_highlight__TDvUs`,
	"sectionSubtitle": `styles_sectionSubtitle__3RvIW`,
	"buyerTextContainer": `styles_buyerTextContainer__atY5V`,
	"buyerDetails": `styles_buyerDetails__RDoky`
};
export default ___CSS_LOADER_EXPORT___;
